import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { LeaderAd } from '~/views/components/adTag/styles';

const HEADER_HEIGHT = '64px';
const MAX_VIDEO_WIDTH = '824px';
const MAX_VIDEO_HEIGHT = '464px';

export const VideoContainer = styled.div<{ $isInline?: boolean }>`
    ${({ $isInline }) =>
        !$isInline &&
        css`
            position: fixed;
            top: ${HEADER_HEIGHT};
            left: 0;
            width: 100vw;
            height: calc(100vh - ${HEADER_HEIGHT});
            z-index: 99;
        `}

    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.Surface.shim};

    .video-js {
        * {
            color: ${({ theme }) => theme.Utility.contrast};
        }

        border-radius: 8px;
        border: none;
        height: auto;
        width: 100%;
        max-width: ${MAX_VIDEO_WIDTH};

        video {
            position: relative;
        }

        &.vjs-fullscreen {
            video {
                max-width: 100%;
                max-height: 100%;
            }
        }
    }

    video {
        position: relative;
        max-width: ${MAX_VIDEO_WIDTH};
        max-height: ${MAX_VIDEO_HEIGHT};
        aspect-ratio: 16/9;
    }
`;

export const ModalWrapper = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}

    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    width: min(95vw, 870px);
    border-radius: 8px;
    background-color: ${({ theme }) => theme.Surface.Opposite.secondary};
    color: ${({ theme }) => theme.Text.OppositeSurface.primary};

    ${LeaderAd} {
        iframe {
            max-width: 100%;
        }
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;

    img {
        height: 28px;
    }
`;

export const InfoContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}

    display: flex;
    width: 100%;
`;

export const MetadataContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}

    display: flex;
    flex-direction: column;
    flex: 2;
`;

export const VideoTitle = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle1}
`;

export const VideoDescription = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body3}
`;

export const Date = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12bCaps']}
`;

export const ShareBarContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: end;
`;
